import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_TRANSACTIONS_FEATURE_GROUP } from './group';

export const PAYMENTS_TRANSACTIONS_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0100',
    name: 'payments_transactions:read',
    description: 'View the transaction table, disputes and suspicious transactions',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_TRANSACTIONS_FEATURE_GROUP.guid,
  },
  EXPORT: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0101',
    name: 'payments_transactions:export',
    description: 'Export the transaction table to CSV, Markdown or Excel',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_TRANSACTIONS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_TRANSACTIONS_FEATURE_GROUP } from './group';

export const PAYMENTS_TRANSACTIONS_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_TRANSACTIONS_FEATURE_GROUP],
  features: featureList(PAYMENTS_TRANSACTIONS_FEATURES),
};
